module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-01-9f9d65879de32290213bfec3a4981df4.svg";